import { ITwrDeviceBackend } from '@app/@types/scenes/scenesDevices'

const filterTwrDevicesForCondition = (devices: Array<ITwrDeviceBackend>):
  Array<ITwrDeviceBackend> => (devices.filter((device: ITwrDeviceBackend) => device.device_type !== 'Siren'))

export default filterTwrDevicesForCondition
